import script from "./FiltrosComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosComponent.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosComponent.vue?vue&type=style&index=0&id=3849ae29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3849ae29"]])

export default __exports__